import { CurrencyField } from '@lingoda/payments';
import { useCurrencyChange } from './utils/useCurrencyChange';
import type { CheckoutPurchase } from './types';

interface CurrencySelectProps {
    purchase: CheckoutPurchase;
}

export const CurrencySelect = ({ purchase }: CurrencySelectProps) => {
    const [currency, handleCurrencyChange] = useCurrencyChange(purchase);

    return <CurrencyField value={currency} onChange={handleCurrencyChange} fullWidth />;
};
